<template>
  <div>
    <vue-recaptcha
      :sitekey="keyRecaptcha"
      @verify="onVerify"
      @error="onRecaptchaError"
      size="invisible"
      @expired="onExpired"
      @render="onRender"
      :load-recaptcha-script="true"
      recaptcha-host="www.recaptcha.net"
      ref="recaptcha"
      class="demo-recaptcha"
      v-if="isCanloadRecaptcha && !canUseGoogleRecaptchaV3"
    />
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import * as Sentry from '@sentry/vue'
import { mapGetters, mapActions } from 'vuex'
import Config from '@/config'
import UnleashService from '@/services/unleash'
import recaptchaV3Service from '@/services/recaptcha-v3'
import Util from '@/util'

export default {
  components: {
    VueRecaptcha,
  },

  data() {
    return {
      isCanloadRecaptcha: false,
    }
  },

  computed: {
    ...mapGetters('googleRecaptchaV3', ['canUseGoogleRecaptchaV3']),
  },

  async created() {
    this.keyRecaptcha = Config.keyRecapcha
    try {
      if (UnleashService) {
        UnleashService.start()
        await UnleashService.ready
      }
      this.isCanloadRecaptcha = true
      if (this.canUseGoogleRecaptchaV3) {
        this.getTokenCaptcharV3()
        return
      }
    } catch (error) {
      this.isCanloadRecaptcha = true
      Sentry.captureException(new Error('Load unleash login error'), {
        extra: {
          error,
        },
      })
    }
  },

  methods: {
    ...mapActions('googleRecaptchaV3', ['resetRecaptchaV2Action']),
    async getTokenCaptcharV3() {
      try {
        const response = await recaptchaV3Service.executeRecaptcha('demo_mode')
        this.onVerify(response)

        Util.trackGA4AndMixpanel(
          'Demo Mode Captchar',
          'reCAPTCHA v3 verified',
        )
      } catch (error) {
        this.onRecaptchaError()
        Sentry.captureException(new Error('Presenter login with reCAPTCHA v3 error'), {
          extra: { error: error.message },
        })
      }
    },
    execute() {
      if (this.canUseGoogleRecaptchaV3) {
        return
      }
      this.$refs.recaptcha.execute()
    },
    onVerify(response) {
      this.$emit('success', response)
    },
    onRender() {
      this.$emit('render')
    },
    onExpired() {
      this.resetRecaptcha()
    },

    resetRecaptcha() {
      this.resetRecaptchaV2Action(this.$refs.recaptcha)
    },
    onRecaptchaError() {
      this.$emit('error')
    },
  },
}
</script>
